routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.categorySales', {
      url: "categories/sales/{productSale}",
      template: `<category-products page-name="B2B-PAG-43" sh-ctrl="shCtrl"></category-products>`
    })
    .state('home.categorySlugProducts', {
      url: "categories-slug/{categorySlug}/products",
      template: `<category-products page-name="B2B-PAG-20" sh-ctrl="shCtrl"></category-products>`
    })
    .state('home.productSearch', {
      url: "categories-search/{searchText}/products",
      template: `<category-products page-name="B2B-PAG-26" search="true" sh-ctrl="shCtrl"></category-products>`
    })
    .state('home.categoryIdProducts', {
      url: "categories-id/{idCategory}/products",
      template: `<category-products page-name="B2B-PAG-20" sh-ctrl="shCtrl"></category-products>`
    })
    .state('home.promotionsProducts', {
      url: "products/{slug}",
      template: `<category-products page-name="B2B-PAG-43" sh-ctrl="shCtrl"></category-products>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/category/category-products/category-products.config.js
 **/